import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getAffiliateUserData } from '../affiliateService'

export const useAffiliateUserData = (refNum: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.AFFILIATE_USER, refNum],
    queryFn: () => getAffiliateUserData(refNum),
    enabled: !!refNum,
  })
}
